import { render, staticRenderFns } from "./ObjetPlainte.vue?vue&type=template&id=1bf5140a"
import script from "./ObjetPlainte.vue?vue&type=script&lang=js"
export * from "./ObjetPlainte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports